import React, { Component } from "react";
import styles from "./styles.module.scss";
import cx from "classnames";
import {
  Col,
  Dropdown,
  FormControl,
  FormGroup,
  InputGroup,
  OverlayTrigger,
  Popover,
  Row,
} from "react-bootstrap";
import { isEqual, sort } from "lodash";
import buildUrl from "build-url-ts";
import PlaceholderEmptyMessage from "src/components/placeholderEmptyMessage";
import RolodexEmptyMessageSvgIcon from "src/legacy/images/homeEmptyMessage.svg";
import DealGraphView from "./scatteredGraph/view";
import { localizedStrings } from 'src/localization/index.jsx';
import DealRow from "./dealRow";
import _ from 'lodash';
import Actions from "src/components/actionbar";
import EmptyMessage from "src/components/emptyMessage";

export default class DealInsightsView extends Component {
  constructor(props) {
    super(props);

    this.localizedDealinsights = localizedStrings.pages.dealInsights;
    this.localizedCommons = localizedStrings.commons;

    this.state = {
      dealType: { name: this.localizedDealinsights.filters.all_deals, value: "all" },
      deals: this.props.allDeals ? this.props.allDeals : [],
      type: "ALL",
      query: "",
      sort: "ai_confidence",
      order: "desc",
      page: 0
    }

    this.handleSortClick = this.handleSortClick.bind(this)
    this.handleOptionSelection = this.handleOptionSelection.bind(this);
    this.handleQuerySubmit = this.handleQuerySubmit.bind(this);
    this._handleSearchQueryChange = this._handleSearchQueryChange.bind(this);
    this.loadMoreDeals = this.loadMoreDeals.bind(this);
    this.handleDealsFetch = this.handleDealsFetch.bind(this);
    this.fetchDeals = this.fetchDeals.bind(this);
    this._getDealType = this._getDealType.bind(this);
  }



  componentDidMount() {

    this.props.fetchIntegrations();

    if (this.props.isIntegrated) {
      this.handleDealsFetch();
    }

  }

  componentWillReceiveProps(nextProps) {

    if (!this.props.isIntegrated && nextProps.isIntegrated) {
      this.handleDealsFetch()
    }

    if (this.props.allDeals != nextProps.allDeals) {
      this.setState({
        deals: nextProps.allDeals
      })
    }


  }

  componentWillUnmount() {
    this.props.invalidateDealInsights();
  }

  handleDealsFetch() {

    if (_.size(_.get(this.props, "location.query")) > 0) {
      const queryObject = this.props.location.query
      const type = _.get(queryObject, "type", "all")
      const query = _.get(queryObject, "query", "")
      const sortBy = _.get(queryObject, "sortBy", "ai_confidence")
      const orderBy = _.get(queryObject, "orderBy", "desc")
      const dealType = this._getDealType(type.toUpperCase())

      this.setState({
        type: type,
        dealType: dealType,
        query: query,
        sort: sortBy,
        order: orderBy.toLowerCase(),
      })
      this.fetchDeals(type, query, sortBy, orderBy)
    }
    else {
      this.updateBrowserUrl();
      this.fetchDeals(this.state.type, this.state.query, this.state.sort, this.state.order)
    }
  }

  fetchDeals(type, query, sortBy, orderBy) {

    var request = {
      type: type.toUpperCase(),
      query: query,
      sort: sortBy,
      stage: "IN_PROGRESS",
      order: orderBy.toUpperCase()
    }

    var params = {
      page: 0,
      limit: 20
    }

    this.props.fetchActiveDeals(request, params);
    this.props.fetchDealsMetrics();
  }

  _getDealType(value) {

    let dealType = {}
    switch (value) {
      case "ALL":
        dealType = {
          name: this.localizedDealinsights.filters.all_deals,
          value: "ALL",
        }
        return dealType;
      case "ON_TARGET":
        dealType = {
          name: this.localizedDealinsights.filters.deals_on_target,
          value: "ON_TARGET",
        }
        return dealType
      case "SLIPPING_AWAY":
        dealType = {
          name: this.localizedDealinsights.filters.deals_slipping_away,
          value: "SLIPPING_AWAY",
        }
        return dealType
      case "AT_RISK":
        dealType = {
          name: this.localizedDealinsights.filters.deals_at_risk,
          value: "AT_RISK",
        }
        return dealType;
      default:
        dealType = {
          name: this.localizedDealinsights.filters.all_deals,
          value: "ALL",
        }

        return dealType
    }

  }

  updateBrowserUrl(source, value) {

    const url = buildUrl(`/deal-insights`, {
      queryParams: {
        type: source === "dropdown" ? value.toLowerCase() : this.state.type.toLowerCase(),
        query: source === "search" ? value : this.state.query,
        sortBy: this.state.sort,
        orderBy: this.state.order
      },
    });

    this.props.navigate(url);
  }

  handleOptionSelection(field) {
    document.body.click();

    this.setState({
      dealType: field,
      type: field.value
    });

    var request = {
      type: field.value.toUpperCase(),
      query: this.state.query,
      sort: this.state.sort,
      stage: "IN_PROGRESS",
      order: this.state.order.toUpperCase()
    }

    var params = {
      page: 0,
      limit: 20
    }

    this.props.fetchActiveDeals(request, params);

    this.updateBrowserUrl("dropdown", field.value)
  }

  handleQuerySubmit(query) {

    this.updateBrowserUrl("search", query);
    this.setState({
      query: query
    })

    var request = {
      type: this.state.type.toUpperCase(),
      query: query,
      sort: this.state.sort,
      stage: "IN_PROGRESS",
      order: this.state.order.toUpperCase(),
    }

    var params = {
      page: 0,
      limit: 20
    }

    this.props.fetchActiveDeals(request, params);

  }

  _handleSearchQueryChange(e) {
    this.setState({
      query: e.target.value
    })
  }

  handleSortClick(value) {

    let order = (this.state.sort === value && this.state.order == "desc") ? "asc" : "desc";

    this.setState((prevState) => {
      return {
        sort: value,
        order: order
      }
    })

    var request = {
      type: this.state.type.toUpperCase(),
      query: this.state.query,
      sort: value,
      stage: "IN_PROGRESS",
      order: order.toUpperCase(),
    }

    var params = {
      page: 0,
      limit: 20
    }
    const url = buildUrl(`/deal-insights`, {
      queryParams: {
        type: this.state.type.toLowerCase(),
        query: this.state.query,
        sortBy: value,
        orderBy: (this.state.sort === value && this.state.order == "desc") ? "asc" : "desc"
      },
    });

    this.props.navigate(url);
    this.props.fetchActiveDeals(request, params);

  }

  handleNavigate() {
    const url = buildUrl(`/settings/integrations/salesforce`);
    this.props.navigate(url);

  }

  loadMoreDeals() {

    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;


    if (!this.props.allDeals) {
      return;
    }

    if (this.props.fetching || nextPage >= totalPages) {
      return;
    }

    const request = {
      type: this.state.type.toUpperCase(),
      query: this.state.query,
      sort: this.state.sort,
      stage: "IN_PROGRESS",
      order: this.state.order.toUpperCase(),
    }

    this.props.fetchActiveDeals(request, { page: nextPage, limit: 20 });

  }

  renderTable() {
    return (
      <div className={styles.dealsTable}>
        {this.renderHeader()}
        <div className={styles.tableWrap}>
          {this.props.totalRecordsCount === 0 && !this.props.fetching && this.renderEmptyMessage()}
          {this.props.totalRecordsCount !== 0 && this.renderTableHeader()}
          {this.props.totalRecordsCount !== 0 && <DealRow currentPage={this.props.currentPage} totalPages={this.props.totalPages} loadMoreDeals={this.loadMoreDeals} deals={this.state.deals} />}
        </div>
      </div>
    );
  }

  renderNotIntegrated() {
    return (
      <div className={styles.notInegrated}>
        <p>
          {this.localizedDealinsights.deal_details.integrate_salesforce.message}
          <button
            className={styles.integrateCRM}
            onClick={() => {
              this.handleNavigate();
            }}
          >
            {this.localizedDealinsights.deal_details.integrate_salesforce.title}
          </button>
        </p>
      </div>
    );
  }

  renderTableHeader() {
    return (
      <div className={styles.headerContainer}>
        <Row className={styles.listTitle}>
          <Col sm={2} onClick={() => { this.handleSortClick("name") }} className={cx(styles.dealTitle, styles.pointer)}>
            {this.localizedDealinsights.headers.all_deals.deal_title}

            {this.state.sort === "name" &&
              <div className={cx(styles.sortIconLeft, { [styles.inverseSortIcon]: this.state.order === "desc", })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }
          </Col>
          <Col sm={2} className={styles.pointer} onClick={() => { this.handleSortClick("accountName") }}>
            {this.localizedDealinsights.headers.all_deals.customer}

            {this.state.sort === "accountName" &&
              <div className={cx(styles.sortIconLeft, styles.accountSortIcon, { [styles.inverseSortIcon]: this.state.order === "desc", })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }
          </Col>
          <Col sm={1} className={cx(styles.pointer)} onClick={() => { this.handleSortClick("amount") }}>
            <span className={styles.pointer} >
              {this.localizedDealinsights.headers.all_deals.value}
            </span>

            {this.state.sort === "amount" &&
              <div className={cx(styles.dealValueSortContainer, { [styles.inverseSortIcon]: this.state.order === "desc", })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }

          </Col>
          <Col sm={1} className={cx(styles.pointer, styles.centerAlign)} onClick={() => { this.handleSortClick("ai_confidence") }} >
            <span>
              {this.localizedDealinsights.headers.all_deals.ai_probability}
            </span>

            {this.state.sort === "ai_confidence" &&
              <div className={cx(styles.sortIconContainer, styles.aiSortIcon, { [styles.inverseSortIcon]: this.state.order === "desc", })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }

          </Col>

          <Col sm={1} className={cx(styles.pointer, styles.centerAlign)} onClick={() => { this.handleSortClick("team_confidence") }}>
            {this.localizedDealinsights.headers.all_deals.team_confidence}

            {this.state.sort === "team_confidence" &&
              <div className={cx(styles.sortIconContainer, { [styles.inverseSortIcon]: this.state.order === "desc", })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }
          </Col>

          <Col sm={1} className={cx(styles.pointer, styles.centerAlign)} onClick={() => { this.handleSortClick("created_date") }}>
            <span>{this.localizedDealinsights.headers.all_deals.creation_date}</span>
            {this.state.sort === "created_date" &&
              <div className={cx(styles.sortIconContainer, styles.createdDateIcon, { [styles.inverseSortIcon]: this.state.order === "desc" })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }
          </Col>

          <Col sm={2} className={styles.pointer} onClick={() => { this.handleSortClick("owner") }}>
            {this.localizedDealinsights.headers.all_deals.owner}

            {this.state.sort === "owner" &&
              <div className={cx(styles.sortIconLeft, styles.ownerSortIcon, { [styles.inverseSortIcon]: this.state.order === "desc", })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }
          </Col>

          <Col sm={1} className={cx(styles.pointer, styles.centerAlign)} onClick={() => { this.handleSortClick("closedDate") }}>
            <span>{this.localizedDealinsights.headers.all_deals.expected_close_date}</span>
            {this.state.sort === "closedDate" &&
              <div className={cx(styles.sortIconContainer, styles.closedDateIcon, { [styles.inverseSortIcon]: this.state.order === "desc", })}>
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }
          </Col>

          <Col sm={1} className={styles.pointer} onClick={() => { this.handleSortClick("modified_date") }}>
            <span >{this.localizedDealinsights.headers.all_deals.last_activity}</span>
            {this.state.sort === "modified_date" &&
              <div className={cx(styles.sortIconContainer, styles.lastActivityIcon, { [styles.inverseSortIcon]: this.state.order === "desc", })} >
                <i className={cx("paperflite-arrow-up")}></i>
                <i className={cx("paperflite-down-arrow", styles.down)}></i>
              </div>
            }
          </Col>
        </Row>
      </div>
    );
  }

  renderEmptyMessage() {

    return (
      <div className={styles.emptyMessage}>
        <EmptyMessage
          width={400}
          image={'/images/assets/assetsEmptyMessage.svg'}
          heading="Looks like no deals present with applied filter"
        />
      </div>

    );
  }

  renderDealTypeFilter() {
    var fields = [
      {
        name: this.localizedDealinsights.filters.all_deals,
        value: "ALL",
      },
      {
        name: this.localizedDealinsights.filters.deals_on_target,
        value: "ON_TARGET",
      },
      {
        name: this.localizedDealinsights.filters.deals_slipping_away,
        value: "SLIPPING_AWAY",
      },
      {
        name: this.localizedDealinsights.filters.deals_at_risk,
        value: "AT_RISK",
      },
    ];

    return <Dropdown>
      <Dropdown.Toggle className={styles.dropdownButton} as={'button'}>
        {this.state.dealType.name} <i className={cx("paperflite-dropdown", styles.down)}></i>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropdownMenuContainer} popperConfig={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 6],
            },
          },
        ],
      }}>
        {fields.map((field, index) => {
          var active = isEqual(this.state.dealType.value, field.value);
          return (
            <Dropdown.Item key={index}
              className={cx(styles.dropdownItem, { [styles.active]: active })}
              onClick={() => this.handleOptionSelection(field)}>
              <span className={styles.type}>{field.name}</span>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  }

  renderHeader() {
    return (
      <div className={styles.dealInsightsHeader}>
        <span className={styles.dealsTypeTitle}>{this.state.dealType.name}</span>
        <div className={styles.headerRight}>
          <div className={styles.inputContainer}>
            <Actions.Search query={this.state.query} onSearch={this.handleQuerySubmit} />
          </div>
          {this.renderDealTypeFilter()}
        </div>
      </div>
    );
  }


  render() {

    return (
      <div className={cx(styles.dealInsights)}>
        <div className={styles.outerContainer}>
          <h1 className={cx(styles.title)}>{this.localizedDealinsights.title}</h1>
          <p className={cx(styles.subTitle)}>
            {this.localizedDealinsights.sub_text}
          </p>

          {this.props.isIntegrated && <div>

            <DealGraphView deals={this.props.allDeals} metrics={this.props.metrics} />

            <div className={styles.body}>{this.renderTable()}</div>
          </div>}

          {this.props.fetching && _.size(this.props.allDeals) === 0 && <p className={styles.loadingMessage}>Loading...</p>}

          {!this.props.isIntegrated && !this.props.isIntegrationsFetching && this.renderNotIntegrated()}

        </div>
      </div>

    );
  }

}